export default Vue => {
  Vue.component("v-input-auth-code", () => import("./v-input-auth-code.vue"));
};
